import type { FeatureFlagRepository } from '#/domain/featureFlag/FeatureFlagRepository'
import type { FeatureFlag } from '#/domain/featureFlag/FeatureFlag'
import type { EnabledFeatureFlag } from '#/domain/featureFlag/EnabledFeatureFlag'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { toDomainList, type FeatureFlagResponseDto } from './FeatureFlagDto'
import {
  toDomainList as toEnabledFlagList,
  type EnabledFeatureFlagResponseDto,
} from './EnabledFeatureFlagDto'

export class HttpFeatureFlagRepository implements FeatureFlagRepository {
  constructor(private readonly http: HttpClientPort) {}

  findProducts(): Promise<string[]> {
    return this.http.get<string[]>('v1/admin/featureflag/products')
  }

  async findByProduct(productName: string): Promise<FeatureFlag[]> {
    const raw = await this.http.get<FeatureFlagResponseDto[]>('v1/admin/featureflag', {
      searchParams: { productName },
    })
    return toDomainList(raw, productName)
  }

  toggle(flagName: string, productName: string, enabled: boolean): Promise<void> {
    return this.http.patch<void>(`v1/admin/featureflag/${encodeURIComponent(flagName)}`, {
      json: { productName, enabled },
    })
  }

  async findEnabledFlags(productName: string, environment?: string): Promise<EnabledFeatureFlag[]> {
    const searchParams: Record<string, string> = { productName }
    if (environment) searchParams.environment = environment

    const raw = await this.http.get<EnabledFeatureFlagResponseDto[]>('v1/featureflag', {
      searchParams,
    })
    return toEnabledFlagList(raw)
  }
}
